import React from "react";
import styled, { createGlobalStyle } from "styled-components";
import Atas from "./components/Atas";
import PenerimaHibah from "./components/PenerimaHibah";
import Bawah from "./components/Bawah";

const GlobalStyle = createGlobalStyle`
html {
  min-height: 100%;
  background: #FFA3B3;
}
a {
  color: black;
}
a:hover {
      background:rgba(255,255,255,0.7);
  }
h1 {
  font-size: 2.5em;
}
h2 {
  border-bottom: 3px solid #000;
}
code {
  font-family: SFMono-Regular,Consolas,Liberation Mono,Menlo,Courier,monospace;
  background:rgba(255,255,255,0.4);
  color: black;
  word-wrap: break-word;
}
ul li, ol li {
line-height:140%; 
}
table {
  border-collapse: collapse;
  background:rgba(255,255,255,0.4);
}
th,
td {
  border: 1px solid #000;
  padding: 0.75rem;
  text-align: left;
}
th {
  font-weight: bold;
  white-space: nowrap;
  background: #000;
  color: #fff;
}
tr:first-of-type th:not(:last-child) {
  border-right-color: transparent;
}
tr:first-child th:first-child,
tr:not(:first-child):not(:last-child) th {
  border-bottom-color: transparent !important;
}
`;

const ContentWrapper = styled.div`
  font-family: "-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif";
  margin-left: auto;
  margin-right: auto;
  max-width: 900px;
  width: 100%;
  padding: 2rem 4rem;
`;

const App = props => {
  return (
    <React.Fragment>
      <GlobalStyle />
      <ContentWrapper>
        <Atas />
        <PenerimaHibah />
        <Bawah />
      </ContentWrapper>
    </React.Fragment>
  );
};

export default App;
